import type { ProjectTask, TaskStatus } from "@/types/models";

export function questionHasAnswer(answer: string | undefined): boolean {
  return Boolean(answer?.trim());
}

export function calculatedWorkItemProgress(
  task: Pick<ProjectTask, "type" | "progress" | "checklist" | "questions">,
): number {
  if (task.type === "checklist") {
    if (!task.checklist.length) return 0;
    return Math.round(
      (task.checklist.filter((item) => item.complete).length /
        task.checklist.length) *
        100,
    );
  }
  if (task.type === "questionnaire") {
    const required = task.questions.filter(
      (question) => question.required !== false,
    );
    if (!required.length) return 0;
    return Math.round(
      (required.filter((question) => questionHasAnswer(question.answer))
        .length /
        required.length) *
        100,
    );
  }
  return task.progress;
}

export function contentDrivenStatus(
  task: Pick<ProjectTask, "type" | "status" | "checklist" | "questions">,
): TaskStatus {
  if (task.type === "checklist") {
    if (task.checklist.length && task.checklist.every((item) => item.complete))
      return "Complete";
    if (["Blocked", "Cancelled", "Not applicable"].includes(task.status))
      return task.status;
    return task.checklist.some((item) => item.complete)
      ? "In progress"
      : "Not started";
  }
  if (task.type === "questionnaire") {
    const required = task.questions.filter(
      (question) => question.required !== false,
    );
    const answered = required.filter((question) =>
      questionHasAnswer(question.answer),
    ).length;
    if (
      required.length &&
      answered === required.length &&
      !["Complete", "Not applicable", "Cancelled", "Blocked"].includes(
        task.status,
      )
    )
      return "In review";
    if (["Blocked", "Cancelled", "Not applicable"].includes(task.status))
      return task.status;
    if (task.status === "Complete" && answered === required.length)
      return "Complete";
    return answered ? "In progress" : "Not started";
  }
  return task.status;
}
